export default "__VITE_ASSET__BQLHZoj4__"